module.exports = __webpack_public_path__ + "static/media/gps.beb8b8ba.png";